import axios from "axios";
import { API_BASE_URL } from "../environment";

const authConfig = () => {
  const token = sessionStorage.getItem("token");
  return token ? { headers: { Authorization: `Bearer ${token}` } } : undefined;
};

export const getLoanProducts = async (data) => {
  const response = await axios.post(`${API_BASE_URL}/getallinterests`, data, authConfig());
  return response.data;
};

export const createLoanProduct = async (data) => {
  const response = await axios.post(`${API_BASE_URL}/interests`, data, authConfig());
  return response.data;
};

export const updateLoanProduct = async (id, data) => {
  const response = await axios.patch(`${API_BASE_URL}/interests/${id}`, data, authConfig());
  return response.data;
};
